import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/use-auth';

const Logout = () => {
  const [loggedOut, setLoggedOut] = useState(false);
  const auth = useAuth();
  const loading = auth.loading;

  useEffect(() => {
    return auth.signout().then(() => {
      setLoggedOut(true);
    });
  }, [auth]);

  if (loading) {
    return <React.Fragment>Loading...</React.Fragment>;
  }

  if (loggedOut) {
    return <Navigate to="/" replace />;
  }

  return <></>;
};

export default Logout;
